import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';

export const upsellElements = () => {
  const cartWrapper = getOnlyElementByAttribute(
    '[data-node-type="commerce-cart-wrapper"]'
  ) as HTMLElement;

  const cartModal = getOnlyElementByAttribute(
    '[data-node-type="commerce-cart-container-wrapper"]'
  ) as HTMLElement;

  const upsellWrapper = getOnlyElementByAttribute(
    '[data-fp="upsell-wrapper"]'
  ) as HTMLElement;

  const closeUpsellArray = document.querySelectorAll(
    '[data-fp="upsell-close"]'
  );

  const openUpsellArray = document.querySelectorAll('[data-fp="upsell-open"]');

  return {
    cartWrapper,
    cartModal,
    upsellWrapper,
    closeUpsellArray,
    openUpsellArray,
  };
};
